import React from 'react';
import { connect } from 'react-redux';
import withRouter from 'js/withRouter';

import { oauthError } from 'actions/LoginActions';
import { updateActiveCms } from 'actions/LayoutActions';
import { parseQs } from 'helpers/http';
import {
  captureApiDocRedirectFromSearch,
  getApiDocRedirectTarget,
  redirectToApiDoc,
} from 'helpers/apiDocRedirect';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';

import Loader from 'components/layout/Loader';

class Login extends React.Component {
  componentWillUnmount = () => {
    this.props.updateActiveCms(null);
  };

  componentDidMount() {
    const query = parseQs(this.props.location.search);

    if (query.error) {
      let uriParts = this.props.location.pathname.split('/');
      this.props.onOauthError(uriParts[2], query.error);
    }

    this.props.updateActiveCms('cmsSystemPageLogin');
    captureApiDocRedirectFromSearch(this.props.location.search);
    this.redirectIfAlreadyAuthenticated();
  }

  componentDidUpdate(prevProps) {
    const wasPending = prevProps.user.loginPending;
    const isReady = !this.props.user.loginPending && this.props.user.logged;
    const sessionRestored = wasPending && isReady;
    const justLoggedIn = !prevProps.user.logged && isReady;

    if (sessionRestored || justLoggedIn) {
      this.redirectIfAlreadyAuthenticated();
    }
  }

  redirectIfAlreadyAuthenticated = () => {
    const { user, appIntl, history, location } = this.props;
    const apiDocReturnPath = getApiDocRedirectTarget(location.search);

    if (apiDocReturnPath && user.logged && !user.loginPending) {
      redirectToApiDoc(apiDocReturnPath);
      return;
    }

    if (!user.logged || user.loginPending) {
      return;
    }

    history.replace(appIntl.urlPrefix + 'account');
  };

  render() {
    const { cmsPage, height, user, location } = this.props;
    const apiDocReturnPath = getApiDocRedirectTarget(location.search);

    if (apiDocReturnPath && user.loginPending) {
      return (
        <div className="content relative" style={{ height: `${height}px` }}>
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%)' }}>
            <Loader />
          </div>
        </div>
      );
    }

    if (user.logged && !user.loginPending) {
      return (
        <div className="content relative" style={{ height: `${height}px` }}>
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%)' }}>
            <Loader />
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        {!cmsPage.data.id && <Data dataName="cmsSystemPageLogin" url="/api/pages/login.json" data={cmsPage} />}

        {cmsPage.pending ? (
          <div className="content relative" style={{ height: `${height}px` }}>
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%)' }}>
              <Loader />
            </div>
          </div>
        ) : (
          <CmsPage data={cmsPage.data} doUpdateActiveCms={false} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    height: state.layout.height,
    user: state.login.user,
    forwardUrl: state.login.forwardUrl,
    appIntl: state.intl,
    cmsPage: state.data.cmsSystemPageLogin,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onOauthError: (service, error) => {
      dispatch(oauthError(service, error));
    },
    updateActiveCms: activeCms => {
      dispatch(updateActiveCms(activeCms));
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login)
);
